import { __read, __spreadArray } from "tslib";
/**
 * Utility function that is used to populate the group= param for deltasync and recent edgeworth calls
 * @param meetingObjectsEnabled Boolean indicating if meeting objects is enabled
 * @param edgeworthTopicsEnabled boolean indicating of topics is enabled
 * @returns a string of form: meetingobjects,topics depending on what is enabled
 */
export function getGroupString(meetingObjectsEnabled, edgeworthTopicsEnabled) {
    var groupArray = __spreadArray(__spreadArray([], __read((meetingObjectsEnabled ? ['meetingobjects'] : [])), false), __read((edgeworthTopicsEnabled ? ['topics'] : [])), false);
    var groupString = groupArray.join(',');
    return groupString;
}
//# sourceMappingURL=getGroupString.js.map